webpackJsonp([123746404564034],{

/***/ 89:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ClientPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageHeader = __webpack_require__(12);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	__webpack_require__(414);
	
	__webpack_require__(89);
	
	var _links = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serviceContent = [{
	  title: "Design",
	  description: "Our design teams are experienced with logo, rebranding, flyer, pamphlet, poster, or sticker design. ",
	  img: "/img/homepage/DESIGNER-SP.svg"
	}, {
	  title: "Photography",
	  description: "Our photography teams are experienced with photographing events, portraits, landscapes, or studio shoots.",
	  img: "/img/homepage/PHOTOGRAPHER-SP.svg"
	}, {
	  title: "Web Development",
	  description: "Our web teams are experienced with helping design interfaces and then develop the web or mobile application.",
	  img: "/img/homepage/DEVELOPER-SP.svg"
	}];
	
	function Services(props) {
	  function ServiceWidget(props) {
	    var service = props.service;
	    return _react2.default.createElement(
	      'div',
	      { className: 'g__flex__col service__widget' },
	      _react2.default.createElement('img', { src: service.img }),
	      _react2.default.createElement(
	        'h4',
	        null,
	        service.title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        service.description
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'g__flex__row service__row' },
	    props.content.map(function (service) {
	      return _react2.default.createElement(ServiceWidget, { service: service });
	    })
	  );
	}
	
	var processContent = [{
	  num: "01",
	  title: "Submit a design request",
	  description: "The first part of the process is filling out the design request form where you will provide basic contact information, basic information about your organization, and a brief summary of your creative project."
	  // button: "View application",
	  // href: "",
	}, {
	  num: "02",
	  title: "Receive a follow-up email",
	  description: "Our VP of Services will reach out to you to discuss feasibility and scope of your creative request."
	}, {
	  num: "03",
	  title: "Be matched with a team",
	  description: "If selected, you will be matched with a team to help you make your project a reality. Your organization will have the opportunity to work with an Innovative Design team on a project over the course of the semester (fall or spring). The Team Lead will reach out to you to finalize the plans for your project and get started."
	}];
	
	var projectPics = [{
	  img: "/img/clients/CLIENTS-1.png",
	  href: ""
	}, {
	  img: "/img/clients/CLIENTS-2.png",
	  href: ""
	}, {
	  img: "/img/clients/CLIENTS-3.png",
	  href: ""
	}];
	
	function ProcessList(props) {
	  function Process(props) {
	    var process = props.process;
	    return _react2.default.createElement(
	      'div',
	      { className: 'g__flex__row process__row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'g__flex__col process__num__col' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'process__num' },
	          process.num
	        ),
	        _react2.default.createElement('hr', { className: 'process__vertical__line' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'g__flex__col' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          process.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          process.description
	        ),
	        process.button ? _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'link__button' },
	          process.button
	        ) : _react2.default.createElement('div', null)
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'g__page__wrapper process__list' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Process'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'g__flex__col' },
	      props.content.map(function (process) {
	        return _react2.default.createElement(Process, { process: process });
	      })
	    )
	  );
	}
	
	// TODO
	function PastList(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'g__flex__row pic__list' },
	    props.pics.map(function (pic) {
	      return _react2.default.createElement('img', { src: pic.img, className: 'pic__img' })
	      // <a href={pic.href}>
	      // </a>
	      ;
	    })
	  );
	}
	
	function ClientPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'clients' },
	    _react2.default.createElement(
	      'div',
	      { className: 'g__page__wrapper our__services' },
	      _react2.default.createElement(_PageHeader2.default, {
	        pageIndicator: 'Clients',
	        title: 'For Organizations',
	        description: 'As a partner, Innovative Design will work with you on your design,  photography, or web design project. Creative work is done pro bono for on campus student  organizations and university programs.'
	      }),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Our services'
	      ),
	      _react2.default.createElement(Services, { content: serviceContent })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'process' },
	      _react2.default.createElement(ProcessList, { content: processContent })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'g__page__wrapper previous' },
	      _react2.default.createElement(_PageHeader2.default, {
	        title: 'Previous Work',
	        description: 'Some of the branding, photography, and website design and development work for previous clients.'
	      }),
	      _react2.default.createElement(
	        'a',
	        { className: 'g__ex__link view__projects', href: _links.behanceClub, target: '_blank' },
	        'View all projects \u2192'
	      ),
	      _react2.default.createElement(PastList, { pics: projectPics })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-clients-js-3789d7f47a3272140551.js